// 月次締め処理 (sidekiq) の進捗ポーリング
// data-running="true" の場合のみポーリングを開始し、success/failed でリロードする
(function () {
  function init() {
    var container = document.getElementById('monthly-closing-polling');
    if (!container) return;
    if (container.getAttribute('data-running') !== 'true') return;

    var statusUrl = container.getAttribute('data-status-url');
    if (!statusUrl) return;

    var POLL_INTERVAL_MS = 1500;
    var MAX_POLL_MS = 5 * 60 * 1000;
    var startedAt = Date.now();
    var inflight = false;

    function showTimeoutNotice() {
      if (document.getElementById('monthly-closing-polling-timeout')) return;
      var notice = document.createElement('div');
      notice.id = 'monthly-closing-polling-timeout';
      notice.className = 'ui warning message';
      notice.style.marginTop = '8px';

      notice.appendChild(document.createTextNode('締め処理の状態確認がタイムアウトしました。'));

      var link = document.createElement('a');
      link.href = '#';
      link.textContent = '最新の状態を確認';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.reload();
      });
      notice.appendChild(link);

      notice.appendChild(document.createTextNode('してください。'));

      container.parentNode.insertBefore(notice, container);
    }

    var intervalId = setInterval(function () {
      if (inflight) return;
      if (Date.now() - startedAt > MAX_POLL_MS) {
        clearInterval(intervalId);
        showTimeoutNotice();
        return;
      }

      inflight = true;
      fetch(statusUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (resp) { return resp.json(); })
        .then(function (data) {
          inflight = false;
          if (data.status === 'success' || data.status === 'failed') {
            clearInterval(intervalId);
            window.location.reload();
          }
        })
        .catch(function () {
          inflight = false;
        });
    }, POLL_INTERVAL_MS);

    window.addEventListener('beforeunload', function () {
      clearInterval(intervalId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
